export class UserStatusConst {
  public static readonly UnRegistered = 1;
  public static readonly Active = 2;
  public static readonly Deactivated = 3;
}
